<template>
  <div class="pedigree-tree">
    <!-- 当前个体 -->
    <div class="pedigree-level level-current">
      <div class="pedigree-card current" :class="item_data.gender === 1 ? 'card-male' : 'card-female'">
        <div class="card-header">
          <span class="gender-icon" :class="item_data.gender === 1 ? 'male' : 'female'">
            <a-icon :type="item_data.gender === 1 ? 'man' : 'woman'" />
          </span>
          <span class="vid-text">{{ item_data.vid }}</span>
          <span class="relation-tag">{{ item_data.gender === 1 ? '公' : '母' }}</span>
        </div>
        <div class="card-body">
          <div class="info-row">
            <span class="info-label">出生日期</span>
            <span class="info-value">{{ item_data.birth_date || '-' }}</span>
          </div>
          <div class="info-row" v-if="item_data.rf_id">
            <span class="info-label">RF-ID</span>
            <span class="info-value">{{ item_data.rf_id }}</span>
          </div>
          <div class="gebv-section">
            <div class="gebv-item" v-if="item_data.gebv_volume != null">
              <span class="gebv-label">产量gebv</span>
              <span class="gebv-value">{{ item_data.gebv_volume }}</span>
            </div>
            <div class="gebv-item" v-if="item_data.gebv_fat != null">
              <span class="gebv-label">脂肪gebv</span>
              <span class="gebv-value">{{ item_data.gebv_fat }}</span>
            </div>
            <div class="gebv-item" v-if="item_data.gebv_protein != null">
              <span class="gebv-label">蛋白gebv</span>
              <span class="gebv-value">{{ item_data.gebv_protein }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 父母代 -->
    <div class="pedigree-level level-parents" v-if="hasParents">
      <div class="level-label">父代</div>
      <div class="parents-container">
        <!-- 父亲 -->
        <div class="parent-branch" v-if="item_data.f_node">
          <div class="pedigree-card card-male clickable" @click="goToItem(item_data.f_node.id)">
            <div class="card-header">
              <span class="gender-icon male">
                <a-icon type="man" />
              </span>
              <span class="vid-text">{{ item_data.f_node.vid }}</span>
              <span class="relation-tag">父亲</span>
            </div>
            <div class="card-body">
              <div class="info-row">
                <span class="info-label">出生日期</span>
                <span class="info-value">{{ item_data.f_node.birth_date || '-' }}</span>
              </div>
              <div class="info-row" v-if="item_data.f_node.rf_id">
                <span class="info-label">RF-ID</span>
                <span class="info-value">{{ item_data.f_node.rf_id }}</span>
              </div>
              <div class="gebv-section">
                <div class="gebv-item" v-if="item_data.f_node.gebv_volume != null">
                  <span class="gebv-label">产量gebv</span>
                  <span class="gebv-value">{{ item_data.f_node.gebv_volume }}</span>
                </div>
                <div class="gebv-item" v-if="item_data.f_node.gebv_fat != null">
                  <span class="gebv-label">脂肪gebv</span>
                  <span class="gebv-value">{{ item_data.f_node.gebv_fat }}</span>
                </div>
                <div class="gebv-item" v-if="item_data.f_node.gebv_protein != null">
                  <span class="gebv-label">蛋白gebv</span>
                  <span class="gebv-value">{{ item_data.f_node.gebv_protein }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 母亲 -->
        <div class="parent-branch" v-if="item_data.m_node">
          <div class="pedigree-card card-female clickable" @click="goToItem(item_data.m_node.id)">
            <div class="card-header">
              <span class="gender-icon female">
                <a-icon type="woman" />
              </span>
              <span class="vid-text">{{ item_data.m_node.vid }}</span>
              <span class="relation-tag">母亲</span>
            </div>
            <div class="card-body">
              <div class="info-row">
                <span class="info-label">出生日期</span>
                <span class="info-value">{{ item_data.m_node.birth_date || '-' }}</span>
              </div>
              <div class="info-row" v-if="item_data.m_node.rf_id">
                <span class="info-label">RF-ID</span>
                <span class="info-value">{{ item_data.m_node.rf_id }}</span>
              </div>
              <div class="gebv-section">
                <div class="gebv-item" v-if="item_data.m_node.gebv_volume != null">
                  <span class="gebv-label">产量gebv</span>
                  <span class="gebv-value">{{ item_data.m_node.gebv_volume }}</span>
                </div>
                <div class="gebv-item" v-if="item_data.m_node.gebv_fat != null">
                  <span class="gebv-label">脂肪gebv</span>
                  <span class="gebv-value">{{ item_data.m_node.gebv_fat }}</span>
                </div>
                <div class="gebv-item" v-if="item_data.m_node.gebv_protein != null">
                  <span class="gebv-label">蛋白gebv</span>
                  <span class="gebv-value">{{ item_data.m_node.gebv_protein }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 祖父母代 -->
    <div class="pedigree-level level-grandparents" v-if="hasGrandparents">
      <div class="level-label">祖代</div>
      <div class="grandparents-container">
        <!-- 父系祖父母 -->
        <div class="grandparent-group" v-if="item_data.f_node && (item_data.f_node.f_node || item_data.f_node.m_node)">
          <div class="group-label">父系</div>
          <div class="grandparent-cards">
            <div class="pedigree-card card-male card-small clickable" v-if="item_data.f_node.f_node" @click="goToItem(item_data.f_node.f_node.id)">
              <div class="card-header">
                <span class="gender-icon male"><a-icon type="man" /></span>
                <span class="vid-text">{{ item_data.f_node.f_node.vid }}</span>
                <span class="relation-tag">祖父</span>
              </div>
              <div class="card-body">
                <div class="info-row">
                  <span class="info-label">出生</span>
                  <span class="info-value">{{ item_data.f_node.f_node.birth_date || '-' }}</span>
                </div>
                <div class="gebv-row">
                  <span v-if="item_data.f_node.f_node.gebv_volume != null">产量gebv: {{ item_data.f_node.f_node.gebv_volume }}</span>
                  <span v-if="item_data.f_node.f_node.gebv_fat != null">脂肪gebv: {{ item_data.f_node.f_node.gebv_fat }}</span>
                </div>
              </div>
            </div>
            <div class="pedigree-card card-female card-small clickable" v-if="item_data.f_node.m_node" @click="goToItem(item_data.f_node.m_node.id)">
              <div class="card-header">
                <span class="gender-icon female"><a-icon type="woman" /></span>
                <span class="vid-text">{{ item_data.f_node.m_node.vid }}</span>
                <span class="relation-tag">祖母</span>
              </div>
              <div class="card-body">
                <div class="info-row">
                  <span class="info-label">出生</span>
                  <span class="info-value">{{ item_data.f_node.m_node.birth_date || '-' }}</span>
                </div>
                <div class="gebv-row">
                  <span v-if="item_data.f_node.m_node.gebv_volume != null">产量gebv: {{ item_data.f_node.m_node.gebv_volume }}</span>
                  <span v-if="item_data.f_node.m_node.gebv_fat != null">脂肪gebv: {{ item_data.f_node.m_node.gebv_fat }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 母系祖父母 -->
        <div class="grandparent-group" v-if="item_data.m_node && (item_data.m_node.f_node || item_data.m_node.m_node)">
          <div class="group-label">母系</div>
          <div class="grandparent-cards">
            <div class="pedigree-card card-male card-small clickable" v-if="item_data.m_node.f_node" @click="goToItem(item_data.m_node.f_node.id)">
              <div class="card-header">
                <span class="gender-icon male"><a-icon type="man" /></span>
                <span class="vid-text">{{ item_data.m_node.f_node.vid }}</span>
                <span class="relation-tag">外祖父</span>
              </div>
              <div class="card-body">
                <div class="info-row">
                  <span class="info-label">出生</span>
                  <span class="info-value">{{ item_data.m_node.f_node.birth_date || '-' }}</span>
                </div>
                <div class="gebv-row">
                  <span v-if="item_data.m_node.f_node.gebv_volume != null">产量gebv: {{ item_data.m_node.f_node.gebv_volume }}</span>
                  <span v-if="item_data.m_node.f_node.gebv_fat != null">脂肪gebv: {{ item_data.m_node.f_node.gebv_fat }}</span>
                </div>
              </div>
            </div>
            <div class="pedigree-card card-female card-small clickable" v-if="item_data.m_node.m_node" @click="goToItem(item_data.m_node.m_node.id)">
              <div class="card-header">
                <span class="gender-icon female"><a-icon type="woman" /></span>
                <span class="vid-text">{{ item_data.m_node.m_node.vid }}</span>
                <span class="relation-tag">外祖母</span>
              </div>
              <div class="card-body">
                <div class="info-row">
                  <span class="info-label">出生</span>
                  <span class="info-value">{{ item_data.m_node.m_node.birth_date || '-' }}</span>
                </div>
                <div class="gebv-row">
                  <span v-if="item_data.m_node.m_node.gebv_volume != null">产量gebv: {{ item_data.m_node.m_node.gebv_volume }}</span>
                  <span v-if="item_data.m_node.m_node.gebv_fat != null">脂肪gebv: {{ item_data.m_node.m_node.gebv_fat }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PedigreeTree',
  props: {
    item_data: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasParents() {
      return this.item_data && (this.item_data.f_node || this.item_data.m_node)
    },
    hasGrandparents() {
      if (!this.item_data) return false
      const f = this.item_data.f_node
      const m = this.item_data.m_node
      return (f && (f.f_node || f.m_node)) || (m && (m.f_node || m.m_node))
    }
  },
  methods: {
    goToItem(id) {
      if (id) {
        this.$router.push(`/breed_items/${id}`)
      }
    }
  }
}
</script>

<style scoped>
.pedigree-tree {
  padding: 16px;
}

/* 当前个体层级 */
.pedigree-level {
  margin-bottom: 24px;
}

.level-label {
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 12px;
  padding-left: 4px;
  font-weight: 500;
  letter-spacing: 1px;
}

/* 卡片基础样式 */
.pedigree-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.25s ease;
  overflow: hidden;
}

.pedigree-card.card-normal {
  min-width: 280px;
}

.pedigree-card.clickable {
  cursor: pointer;
}

.pedigree-card.clickable:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

/* 当前个体卡片 */
.pedigree-card.current {
  max-width: 360px;
  margin: 0 auto;
}

.pedigree-card.current.card-male {
  border-left: 3px solid #1890ff;
}

.pedigree-card.current.card-female {
  border-left: 3px solid #eb2f96;
}

.pedigree-card.card-male {
  border-left: 3px solid #1890ff;
}

.pedigree-card.card-female {
  border-left: 3px solid #eb2f96;
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
}

.gender-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.gender-icon.male {
  background: #e6f7ff;
  color: #1890ff;
}

.gender-icon.female {
  background: #fff0f6;
  color: #eb2f96;
}

.vid-text {
  font-size: 16px;
  font-weight: 700;
  color: #000;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.relation-tag {
  font-size: 11px;
  color: #8c8c8c;
  background: #f5f5f5;
  padding: 3px 10px;
  border-radius: 12px;
  font-weight: 500;
  flex-shrink: 0;
}

/* 卡片主体 */
.card-body {
  padding: 12px 16px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.info-row.compact {
  margin-bottom: 4px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  font-size: 12px;
  color: #8c8c8c;
}

.info-value {
  font-size: 13px;
  color: #262626;
}

/* GEBV 数据 */
.gebv-section {
  display: flex;
  gap: 20px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #e8e8e8;
}

.gebv-item {
  text-align: center;
  flex: 1;
}

.gebv-label {
  display: block;
  font-size: 11px;
  color: #8c8c8c;
  margin-bottom: 4px;
}

.gebv-value {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #1890ff;
}

.gebv-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e8e8e8;
  font-size: 12px;
  color: #595959;
}

.gebv-row span {
  background: #f5f5f5;
  padding: 4px 10px;
  border-radius: 4px;
  display: inline-block;
}

/* 父母代布局 */
.parents-container {
  display: flex;
  gap: 40px;
  justify-content: center;
  margin-top: 16px;
}

.parent-branch {
  flex: 1;
  max-width: 360px;
  min-width: 280px;
}

/* 祖父母代布局 */
.grandparents-container {
  display: flex;
  gap: 40px;
  justify-content: center;
  margin-top: 16px;
}

.grandparent-group {
  flex: 1;
  max-width: 480px;
}

.group-label {
  font-size: 12px;
  color: #8c8c8c;
  margin-bottom: 16px;
  text-align: center;
  font-weight: 500;
}

.grandparent-cards {
  display: flex;
  gap: 24px;
  justify-content: center;
}

.grandparent-cards .pedigree-card {
  flex: 1;
  max-width: 220px;
  min-width: 160px;
}

/* 小尺寸卡片 */
.pedigree-card.card-small {
  border-radius: 10px;
}

.pedigree-card.card-small .card-header {
  padding: 12px 16px;
}

.pedigree-card.card-small .card-body {
  padding: 12px 16px;
}

.pedigree-card.card-small .gender-icon {
  width: 24px;
  height: 24px;
  font-size: 12px;
}

.pedigree-card.card-small .vid-text {
  font-size: 14px;
}

.pedigree-card.card-small .info-row {
  margin-bottom: 8px;
}

.pedigree-card.card-small .gebv-row {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e8e8e8;
}

/* 响应式 */
@media (max-width: 768px) {
  .parents-container {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
  
  .parent-branch {
    max-width: 100%;
    width: 100%;
  }
  
  .grandparents-container {
    flex-direction: column;
    gap: 24px;
  }
  
  .grandparent-group {
    max-width: 100%;
  }
  
  .grandparent-cards {
    flex-direction: column;
    gap: 16px;
  }
  
  .grandparent-cards .pedigree-card {
    max-width: 100%;
  }
  
  .pedigree-card.current {
    max-width: 100%;
  }
}
</style>
